import { Component, OnDestroy, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { VERSION, VERSIONDATE } from '../../app.constants';
import { Principal } from '../../shared';
import { ApiService } from '../../shared/services/api.service';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { User } from '../../entities/user.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit, OnDestroy {

  alive: boolean;
  interval: number;

  pimcoreUrl = environment.pimcore;
  version: string;
  versionDate: string;
  roles: string[];
  user: User;
  badges: {
    planning: string,
    open_accountings: string,
    archive: string,
    base_data: string,
    marketwebsite_changes: string,
    emplyee: string,
    messages: string,
    evaluation: string,
    documents: string,
    administration: string
  };

  constructor(private router: Router,
              private principal: Principal,
              private apiService: ApiService) {
    this.version = 'Version: ' + VERSION;
    this.versionDate = VERSIONDATE;
    this.router = router;
    this.principal.identity().then(account => {
      this.roles = account.authorities;
      this.user = account;
    }, error => {
      this.roles = [];
    });

    this.badges = {
      planning: null,
      open_accountings: null,
      archive: null,
      base_data: null,
      marketwebsite_changes: null,
      emplyee: null,
      messages: null,
      evaluation: null,
      documents: null,
      administration: null
    };

    this.alive = true;
    this.interval = 60000; // 300000;
  }

  ngOnInit() {
    TimerObservable.create(0, this.interval)
      .takeWhile(() => this.alive)
      .subscribe(() => {
        const currentDate = new Date();
        /*console.log('[Timed Event: ' +
          ('0' + currentDate.getHours()).slice(-2) + ':' +
          ('0' + currentDate.getMinutes()).slice(-2) + ':' +
          ('0' + currentDate.getSeconds()).slice(-2) + '] - SidebarData');
        */
        this.getSidebarData();
      });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  getSidebarData() {
    this.apiService.get('backoffice/sidebar-data')
      .subscribe(response => {
        const sidebarData = response.json() as {id: number, item: string, count: number, branch: string}[];

        let allPlanning = 0;
        sidebarData.filter(elem => elem.item === 'planning').forEach(elem => allPlanning += elem.count);

        let allOpenAccountings = 0;
        sidebarData.filter(elem => elem.item === 'open_accountings').forEach(elem => allOpenAccountings += elem.count);

        let allBaseData = 0;
        sidebarData.filter(elem => elem.item.startsWith('base_data') || elem.item === 'marketwebsite_changes')
          .forEach(elem => allBaseData += elem.count);

        let allMarketwebsiteChanges = 0;
        sidebarData.filter(elem => elem.item.startsWith('marketwebsite_changes')).forEach(elem => allMarketwebsiteChanges += elem.count);

        sidebarData.push({
          id: 100,
          item: 'planning',
          branch: '01 - Geschäftsführung',
          count: allPlanning
        });

        sidebarData.push({
          id: 200,
          item: 'open_accountings',
          branch: '01 - Geschäftsführung',
          count: allOpenAccountings
        });

        sidebarData.push({
          id: 1000,
          item: 'base_data',
          branch: '01 - Geschäftsführung',
          count: allBaseData
        });

        sidebarData.push({
          id: 2000,
          item: 'marketwebsite_changes',
          branch: '01 - Geschäftsführung',
          count: allMarketwebsiteChanges
        });

        this.badges.base_data = null;

        const branchString = (this.user.contact.branchString === '09 - allg. Verwaltung') ?
          '01 - Geschäftsführung' : this.user.contact.branches;

        Object.keys(this.badges).map(badgeKey => {
          if (badgeKey === 'base_data') {
            const baseDataSidebarDataItems = sidebarData.filter(element =>
              (element.item.startsWith(badgeKey) || element.item === badgeKey)
              && branchString.includes(element.branch));
            if (baseDataSidebarDataItems.length > 0 ) {
              const branchSum = baseDataSidebarDataItems.map(item => item.count).reduce((a, b) => a + b);
              this.badges.base_data = branchSum.toString() || null;
            }
          } else {
            let count = 0;
            const sidebarDataItems = sidebarData.filter(element => element.item === badgeKey
              && branchString.includes(element.branch));
            sidebarDataItems.forEach(item => {
              count += item.count;
            });

            if (sidebarDataItems) {
              this.badges[badgeKey] = count.toString() || null;
            }
          }
        });
      });
  }

  showMenuItem(roles: string[]) {
    return roles.some(element => {
      return this.roles.indexOf(element) >= 0;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/layouts/sidebar/sidebar.component.ts